import React from 'react'

export default function Info({
  extraClass
}) {
  return (
    <div className={`${extraClass ? extraClass : ""} sticky-md-top d-flex flex-column justify-content-between`}>
      <div>
        <h1 className="text-gold fw-normal letter-spacing-lg border-bottom text-center mt-3 mt-md-0 mb-3">ARCHICAT</h1>
        <div className="d-flex flex-column">
          <div className='d-flex justify-content-center mb-4'>
            <img className='w-75' src="/images/avatar.png" alt="Profile avatar" />
          </div>
          <p><b className="text-body">Name:</b><br/>Christine Nguyen</p>
          <p><b className="text-body">Email:</b><br/><a className="link text-gold text-break" href="mailto:phuongnguyen140889@gmail.com">Contact me</a></p>
          <p><b className="text-body">About me:</b><br/>
            I'm cat and a 'new kid on the block' in Architectural Technology, and that's why I named my studio Archicat.
          </p>
          <p><a rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/christinenguyen1989/"><img src="/images/linkedin-icon.svg" alt="LinkedIn icon"/></a></p>
        </div>
      </div>
      <p className='fs-8 text-secondary text-opacity-75 d-none d-md-inline-block'><i>All right reserved © Christine Nguyen</i></p>
    </div>
  )
}
